export default "__VITE_ASSET__wyTRp8iE__"